<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <!--統計總覽-->
        <v-row class="mb-2">
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="grey--text text--darken-1 text-subtitle-2">
                取券人數
              </div>
              <div class="text-h4 font-weight-black primary--text">
                {{ totalUserCount.toLocaleString() }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="grey--text text--darken-1 text-subtitle-2">
                取券張數
              </div>
              <div class="text-h4 font-weight-black text--primary">
                {{ totalTicketCount.toLocaleString() }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card outlined class="pa-4">
              <div class="grey--text text--darken-1 text-subtitle-2">
                取券公司數
              </div>
              <div class="text-h4 font-weight-black text--primary">
                {{ desserts.length.toLocaleString() }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-data-table
          ref="vDataTable"
          :headers="headers"
          :items="desserts"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          :loading="isLoading"
          loading-text="資料讀取中..."
          no-data-text="暫時沒有符合的資料"
          item-key="companyKey"
          show-expand
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>取券統計</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-menu
                v-model="menuMonth"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="month"
                    label="統計月份"
                    prepend-icon="mdi-calendar"
                    readonly
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                    style="max-width: 160px"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="month"
                  type="month"
                  locale="zh-tw"
                  :max="maxMonth"
                  @change="onMonthChange"
                ></v-date-picker>
              </v-menu>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                color="blue-grey"
                style="height: 40px"
                depressed
                dark
                class="mb-2 mt-2 mr-2"
                :disabled="!desserts.length"
                @click="exportAllCsv"
              >
                匯出 CSV
              </v-btn>
              <v-btn
                color="blue-grey"
                style="height: 40px"
                depressed
                dark
                class="mb-2 mt-2"
                :loading="isLoading"
                @click="getTicketLog"
              >
                重新整理
              </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:[`item.userCount`]="{ item }">
            {{ item.userCount.toLocaleString() }}
          </template>
          <template v-slot:[`item.ticketCount`]="{ item }">
            {{ item.ticketCount.toLocaleString() }}
          </template>

          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>

          <!--展開內容 : 取券明細-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <v-container class="my-4">
                      <div class="d-flex align-center mb-3">
                        <div>
                          <div
                            class="grey--text text--darken-1 text-subtitle-2 font-weight-regular"
                          >
                            No.{{ item.taxIdNumber }}
                          </div>
                          <p
                            class="text-h5 font-weight-black text--primary mb-0"
                          >
                            {{ item.companyName }} - 取券明細
                          </p>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          small
                          color="blue-grey"
                          class="white--text"
                          @click="exportCsv(item)"
                        >
                          匯出 CSV
                        </v-btn>
                      </div>
                      <v-data-table
                        :headers="detailHeaders"
                        :items="item.records"
                        no-data-text="查無取券資料"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.url`]="{ item }">
                          <a
                            v-if="item.url"
                            :href="item.url"
                            target="_blank"
                            rel="noopener"
                            >{{ item.url }}</a
                          >
                        </template>
                      </v-data-table>
                    </v-container>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="1"></v-col
    ></v-row>
  </v-container>
</template>

<script>
import { internalApiAxios } from "@/api";

// 取券紀錄 API
const TICKET_LOG_API = "/Ticket/GetTicketLogByYYYYMM";

// 取得 n 個月前的 yyyy-MM（預設上個月）
const monthsAgo = (n) => {
  const date = new Date();
  date.setDate(1);
  date.setMonth(date.getMonth() - n);
  return `${date.getFullYear()}-${`${date.getMonth() + 1}`.padStart(2, "0")}`;
};

export default {
  data: () => ({
    search: "",
    expanded: [],
    singleExpand: false,
    isLoading: false,
    menuMonth: false,
    // 預設顯示上個月
    month: monthsAgo(1),
    maxMonth: monthsAgo(0),
    headers: [
      {
        text: "公司名稱",
        value: "companyName",
        align: "start",
      },
      {
        text: "統一編號",
        value: "taxIdNumber",
        align: "center",
        width: "16%",
      },
      {
        text: "取券人數",
        value: "userCount",
        align: "end",
        width: "16%",
      },
      {
        text: "取券張數",
        value: "ticketCount",
        align: "end",
        width: "16%",
      },
      {
        text: "展開",
        value: "data-table-expand",
        sortable: false,
        align: "center",
        width: "6%",
      },
    ],
    detailHeaders: [
      { text: "員工編號", value: "useR_NO", align: "center", width: "12%" },
      { text: "票券編號", value: "tickeT_NO", align: "center", width: "18%" },
      { text: "票券 ID", value: "tickeT_ID", align: "center", width: "18%" },
      {
        text: "取券時間",
        value: "creatioN_DATE_YMDHMS",
        align: "center",
        width: "18%",
      },
      { text: "票券連結", value: "url", align: "start" },
    ],
    desserts: [],
    // 統編可能是純數字字串，若用陣列存，Vue 的 $set 會把陣列撐到該索引長度而卡死
    transitioned: {},
    closeTimeouts: {},
  }),
  computed: {
    totalTicketCount() {
      return this.desserts.reduce((sum, i) => sum + i.ticketCount, 0);
    },
    totalUserCount() {
      return this.desserts.reduce((sum, i) => sum + i.userCount, 0);
    },
  },
  watch: {
    singleExpand(v) {
      if (!v) return;
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  created() {
    this.$bus.$emit("sideBarSelectedItem:push", 13);
    this.getTicketLog();
  },

  methods: {
    onMonthChange() {
      this.menuMonth = false;
      this.getTicketLog();
    },
    async getTicketLog() {
      this.isLoading = true;
      this.expanded = [];
      this.transitioned = {};
      // API 參數格式為 yyyyMM
      const yyyyMM = this.month.replace("-", "");
      await internalApiAxios({
        method: "post",
        url: `${TICKET_LOG_API}?yyyyMM=${yyyyMM}`,
      })
        .then((res) => {
          const data = res.data;
          const result = Array.isArray(data) ? data : (data && data.result) || [];
          this.desserts = this.groupByCompany(result);
          if (this.desserts.length === 0) {
            this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
          this.desserts = [];
          this.$snackbar.add(`取得取券紀錄失敗 : ${error}`, { color: "error" });
        });
      this.isLoading = false;
    },
    // 取券紀錄為單張票券一筆，依公司彙總後計算人數（同一員工只算一人）
    groupByCompany(records) {
      const map = {};
      records.forEach((record) => {
        const key = record.taX_ID_NUMBER || record.companY_NAME || "-";
        if (!map[key]) {
          map[key] = {
            companyKey: key,
            companyName: record.companY_NAME,
            taxIdNumber: record.taX_ID_NUMBER,
            records: [],
            users: new Set(),
          };
        }
        map[key].records.push(record);
        map[key].users.add(record.useR_NO);
      });
      return Object.values(map)
        .map((company) => ({
          companyKey: company.companyKey,
          companyName: company.companyName,
          taxIdNumber: company.taxIdNumber,
          records: company.records,
          ticketCount: company.records.length,
          userCount: company.users.size,
        }))
        .sort((a, b) => b.userCount - a.userCount);
    },
    toCsv(cols, rows) {
      const escape = (v) =>
        `"${String(v == null ? "" : v).replace(/"/g, '""')}"`;
      return [
        cols.map((c) => escape(c.text)).join(","),
        ...rows.map((row) => cols.map((c) => escape(row[c.value])).join(",")),
      ].join("\r\n");
    },
    download(csv, fileName) {
      // 加上 BOM 讓 Excel 正確辨識 UTF-8
      const blob = new Blob(["﻿" + csv], {
        type: "text/csv;charset=utf-8;",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    exportCsv(item) {
      const csv = this.toCsv(this.detailHeaders, item.records);
      this.download(
        csv,
        `取券明細_${this.month}_${item.companyName}_${item.taxIdNumber}.csv`
      );
    },
    // 總表 CSV 展開到員工層級，每張票券一列並帶上所屬公司
    exportAllCsv() {
      const cols = [
        { text: "公司名稱", value: "companyName" },
        { text: "統一編號", value: "taxIdNumber" },
        { text: "取券人數", value: "userCount" },
        { text: "取券張數", value: "ticketCount" },
        ...this.detailHeaders,
      ];
      const rows = [];
      this.desserts.forEach((company) => {
        company.records.forEach((record) => {
          rows.push({
            companyName: company.companyName,
            taxIdNumber: company.taxIdNumber,
            userCount: company.userCount,
            ticketCount: company.ticketCount,
            ...record,
          });
        });
      });
      const csv = this.toCsv(cols, rows);
      this.download(csv, `取券統計_${this.month}.csv`);
    },
    getItemId(item) {
      return item.companyKey;
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        clearTimeout(this.closeTimeouts[id]);
        props.expand(true);
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      this.$set(this.transitioned, id, false);
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
  },
};
</script>
<style></style>
